import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from "@angular/core";
import { AuthService } from "./services/auth.service";
import { FeatureFlagService } from "./services/feature-flag.service";

/**
 * Feature flags at bootstrap, in two steps (see FeatureFlagService):
 *
 *  1. Read the environment's mounted ui-app-config.json before the first
 *     component renders, so `FeatureFlagService.get()` is safe anywhere.
 *     Falls back to the committed values on failure — never blocks bootstrap.
 *  2. Follow the BFF's shared flag file while `AuthService.signedIn$` holds —
 *     profile loaded AND access token present. On a hard reload the profile
 *     is back from sessionStorage before authGuard has set the token; the sync
 *     starts the moment the token is set (no router event needed), and a
 *     token-less poll never drags in the refresh / session-expired flow.
 */
export function provideFeatureFlags(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const featureFlags = inject(FeatureFlagService);
    featureFlags.startRemoteSync(inject(AuthService).signedIn$);
    return featureFlags.read();
  });
}
